import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment.prod';

const url = environment.imgUrl;

@Pipe({
  name: 'imagen'
})
export class ImagenPipe implements PipeTransform {
  transform(img: string): string {
    if (!img) {
      // console.log('imgURL: ', url + '/assets/images/imgnotfound.png');
      return '/assets/images/imgnotfound.png';
    }
    return url + img;
  }
}
